import { Dispatch } from 'react';
import { request } from './request';
import { SessionAction } from '../interfaces/Session';

interface PostResetProps {
  username: string,
  resetType: string,
}

export function postReset(dispatch: Dispatch<SessionAction>, props: PostResetProps) {
  return request(dispatch, '/auth/reset', {
    auth: false,
    method: 'POST',
    body: {
      ...props,
    },
  });
}
